module.exports = __webpack_public_path__ + "img/sebastian-hagens-1@2x.9a0c7be8.jpg";